import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store/store';

interface ParticipantState {
  tenantId: string | null;
  isOrigin: string | null;
}

const sliceState: ParticipantState = {
  // tenantId: localStorage.getItem('tenantId') ?? null,
  // isOrigin: localStorage.getItem('isOrigin') ?? null,
  tenantId: null,
  isOrigin: null,
};

const customerSwitchSlice = createSlice({
  name: 'customerSwitch',
  initialState: sliceState,
  reducers: {
    setSwitchCredentials: (
      state,
      { payload: { tenantId, isOrigin } }: PayloadAction<{ tenantId: string; isOrigin: string }>
    ) => {
      state.tenantId = tenantId;
      state.isOrigin = isOrigin;
    },
  },
});

export const { setSwitchCredentials } = customerSwitchSlice.actions;

export default customerSwitchSlice.reducer;

export const selectTenantId = (state: RootState): string | null => state?.switch?.tenantId;

export const selectIsOrigin = (state: RootState): string | null => state?.switch?.isOrigin;
